// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"d1d34f05","486":"daf0b3d8"}[chunkId] + ".chunk.css";
};